function validateTagNameProperty(value: string, siblingNames: string[]) {
  let error = null;

  // Check if '/' is included in the input name
  error = value.includes('/') ? `'/' cannot be included in the tag name` : null;
  // Check if the input name already exists among the siblings of its parent
  // NOTE: This error overwrites the first one (because it is rarer case)
  error = siblingNames.includes(value)
    ? `'${value}' already exists on the same level`
    : error;

  return error;
}

export { validateTagNameProperty };
